import type {State} from 'src/reducers';
import type {Thread, PopulatedThread} from 'src/types/messages';

import {createSelector} from 'reselect';

import {values} from 'src/utils/object';
import {selectPopulatedThreadsByIds} from 'src/selectors/messages-v2';


export const getThreads = (
  state: State,
): {
  [key: string]: Thread;
} => state.messages.threads;

export const selectThread = (
  state: State,
  threadId: string,
): Thread | null | undefined => state.messages.threads[threadId];

export const selectThreadsAsArray: (state: State) => Thread[] = createSelector(
  getThreads,
  (threads): Thread[] => values(threads),
);

export const selectOrderedThreads = (state: State): PopulatedThread[] =>
  selectPopulatedThreadsByIds(state, state.messages.threadOrder);

// @ts-expect-error - TS2322 - Type 'OutputParametricSelector<any, string, Thread | undefined, (res1: Thread[], res2: string) => Thread | undefined>' is not assignable to type '(state: any, contactId: string) => Thread'.
export const selectThreadForContact: (
  state: State,
  contactId: string,
) => Thread = createSelector(
  selectThreadsAsArray,
  // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
  (_, contactId: string) => contactId,
  (threads, contactId) =>
    threads.find((thread) => thread.contactId === contactId),
);
